
import * as _ from 'lodash';
import {getAPI_URL} from '../utils/functions';
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

const initialState = {
  socket: null,
  stompClient: null,
  isConnected: false
}

export const sockets = {
  namespaced: true,
  state: initialState,
  actions: {
    connectServer({ commit,dispatch }, payload) {
      // let socket = new SockJS(`${getAPI_URL()}sockets`);
      let socket = new SockJS(`${getAPI_URL()}sockets`,null,{transports:["xhr-streaming","xhr-polling"]});
      let stompClient = Stomp.over(socket,{protocols:['v99.stomp', 'v12.stomp']});
      stompClient.debug = () => "";
      stompClient.connect(
          { username: payload.username },
          () => {
            commit('connectSuccess', {socket,stompClient})
          },
          (error) => {
            console.log(error);
          }
      );
    },
    disconnectServer({ commit,dispatch }, payload) {
      if(payload.stompClient){
        payload.stompClient.disconnect();
      }
      commit('disconnectSuccess', {})
    }
  },
  getters: {
    socket: state => state.socket,
    stompClient: state => state.stompClient,
    isConnected: state => state.isConnected
  },
  mutations: {
    connectSuccess(state, payload) {
      state.socket = payload.socket;
      state.stompClient = payload.stompClient;
      state.isConnected = true;
    },
    disconnectSuccess(state, payload) {
      state.socket = null;
      state.stompClient = null;
      state.isConnected = false;
    }
  },
};

export default sockets;



// WEBPACK FOOTER //
// ./src/store/sockets.module.js